import React, { useEffect, useState } from "react";
import PlanCard from "../../Components/PlanCard";
import { getAllSubscriptionPlans, assignSubPlan, confirmSubscriptionAfterPayment } from "../../apis/subscription";
import Loading from "../../ReusableFunctions/Loader";
import Popup from "../../ReusableFunctions/Popup";
import { useDispatch, useSelector } from "react-redux";
import LoaderComponent from "../../ReusableComponents/LoaderComponent";
import { setUser } from "../../reducers/userReducer";
import Modal from "../../ReusableComponents/Modal";
import { formatAmountWithSymbol } from "../../ReusableFunctions/reusableFunctions";

const SubscriptionPlans = () => {
  const user = useSelector(state => state.user.user)
  const dispatch = useDispatch();
  const [isMonthly, setIsMonthly] = useState(false);
  const [plans, setPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [loading, setLoading] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [planDetails, setPlanDetails] = useState(null);
   const [razorpayData, setRazorpayData] = useState(null);
  const [gstAmount, setGstAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  const getAllPlans = async () => {
    setLoading(true);
    let allPlans = await getAllSubscriptionPlans(isMonthly ? "monthly" : "yearly");
    const filtered = allPlans.subPlans.filter(
      (plan) => plan.type.trim().toLowerCase() !== "trial"
    );
    setPlans(filtered);
     const defaultPlan = isMonthly?filtered.find((plan)=>plan.name==="Standard Plan"): filtered.find(plan => plan.name === "Standard Plus Plan");
    if (defaultPlan) setSelectedPlanId(defaultPlan.id);
    setLoading(false);
  }

  useEffect(() => {
    getAllPlans()
  }, [isMonthly]);
    const openRazorpayCheckout = async () => {
      const { payload } = planDetails;
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        subscription_id: razorpayData?.razorpay_subscription_id,
        name: "BhuMeet",
        image: process.env.REACT_APP_STORE_LOGO_URL,
        prefill: {
          email: user?.email || "user@example.com",
          contact: user?.phone || "9999999999",
        },
        theme: { color: "#0D6EFD" },
        handler: async function (response) {
          if (response.razorpay_payment_id || response.razorpay_subscription_id) {
            const updatedUser = {
              ...user,
              subscription: {
                ...user.subscription,
                razorpay_status: "active",
              },
            };
            dispatch(setUser(updatedUser));

            await confirmSubscriptionAfterPayment({
              ...payload,
              razorpay_subscription_id: razorpayData?.razorpay_subscription_id,
              razorpay_status: "active",
              razorpay_short_url: razorpayData?.razorpay_short_url,
              razorpay_customer_id: razorpayData?.razorpay_customer_id,
            });

            Popup.alert(
            "Subscription Upgraded!",
            "Your subscription has been successfully upgraded. New features are now available in your account.",
            "SUCCESS",
            (() => window.location.href = "/"),
            null,
            "Continue",
            null,
            null,
            "16px"
          );
        } else {
          // Fallback for unknown cases
          Popup.alert(
            "Payment Failed",
            "Something went wrong during the transaction. Please try again.",
            "ERROR",
            null,
            null,
            "Retry",
            null,
            null,
            "16px"
          );
        }
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on('payment.failed', function (response) {
      console.log("on failed", response)
      Popup.alert(
        "Payment Failed",
        response.error.description,
        "ERROR",
        null,
        null,
        "Ok",
        null,
        null,
        "16px"
      );
    });
    rzp.open();
  }


const handlePlanSelect = async (plan) => {
  try {
    const startDate = new Date();
    const endDate = new Date(startDate);
    if (isMonthly) endDate.setMonth(endDate.getMonth() + 1);
    else endDate.setFullYear(endDate.getFullYear() + 1);

    const payload = {
      user_id: user.dsp?.id,
      plan_id: plan.id,
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      type: isMonthly ? "monthly" : "yearly",
      is_dsp_promoted: user.dsp?.is_dsp_promoted,
    };

    Loading.set(true);
    const { razorpaySubscription } = await assignSubPlan(payload);
    Loading.set(false);

    if (razorpaySubscription?.razorpay_subscription_id) {
      const gstRate = 0.18;
      const baseAmount = Number(plan?.base_price || 0);
      const gst = baseAmount * gstRate;
      const total = baseAmount + gst;

      setPlanDetails({ ...plan, payload });
      setRazorpayData(razorpaySubscription);
      setGstAmount(gst);
      setTotalAmount(total);
      setShowConfirmModal(true); // open modal
    } else {
      Popup.alert("Something went wrong", "No subscription ID returned.", "ERROR");
    }
  } catch (err) {
    Loading.set(false);
    Popup.alert("Subscription creation failed!", err.message, "ERROR");
  }
};

  return (
    <div className="main-wraper-container">
      <section className="w-full h-screen flex flex-col items-center p-6">
        <h2 className="text-3xl font-bold mb-6 text-center">
          Upgrade to more get out of subscription
        </h2>

        <div className="flex items-center mb-10 gap-4 bg-[#D3DEF3] p-2 rounded-full">
          <button
            onClick={() => setIsMonthly(false)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition ${!isMonthly ? "bg-[#0C1831] text-white shadow-md" : "text-gray-600"
              }`}
          >
            Yearly
          </button>
          <button
            onClick={() => setIsMonthly(true)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition ${isMonthly ? "bg-[#0C1831] text-white shadow-md" : "text-gray-600"
              }`}
          >
            Monthly
          </button>
        </div>
        {loading ?
          <LoaderComponent width={"2%"} height={"2%"} />
          :
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 px-6 max-w-8xl">
              {plans.map((plan, index) => (
                <PlanCard
                  key={plan.id}
                  plan={{ ...plan, highlight: plan.id === selectedPlanId, isRecommended: index === 2, }}
                  user={user}
                  onSelectPlan={handlePlanSelect}
                  setSelectedPlanId={setSelectedPlanId}
                  isMonthly={isMonthly}
                />
              ))}
            </div>
            <div className="flex w-[100%]  px-6 py-4 justify-end font-manrope  text-[13px] font-[600] gap-1 items-center mb-1 ">
              <span className="text-red-600 mt-1">*</span>
              <span className="italic"> Prices are exclusive of GST.</span>
            </div>
          </div>
        }
      </section>
     {showConfirmModal && (
 <Modal
  onClose={() => setShowConfirmModal(false)}
  open={showConfirmModal}
  contentStyle={{
    width: "400px",
    borderRadius: "10px",
    background: "#fff",
    padding: "24px",
    height:"400px",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
  }}
>
  <div style={{ display: "flex", flexDirection: "column" }}>
    {/* Header */}
    <div style={{ marginBottom: "20px" }}>
      <h2 style={{ fontSize: "24px", fontWeight: "700", margin: "0", color: "#1E1E1E" }}>
       Bill Summary
      </h2>
      <p style={{ fontSize: "14px", color: "#666", marginTop: "4px" }}>
             Review your subscription plan before proceeding
      </p>
    </div>

    {/* Order Details */}
    <div style={{ marginBottom: "20px", paddingBottom: "10px", borderBottom: "1px solid #ddd" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <span style={{ color: "#666" }}>Plan:</span>
        <span style={{ fontWeight: "600" }}>{planDetails?.name}</span>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <span style={{ color: "#666" }}>Plan Amount:</span>
        <span style={{ fontWeight: "600" }}>{formatAmountWithSymbol(planDetails?.base_price,user?.country_code)}</span>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span style={{ color: "#666" }}>GST (18%):</span>
        <span style={{ fontWeight: "600" }}>{formatAmountWithSymbol(gstAmount,user?.country_code)}</span>
      </div>
    </div>

    {/* Total */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#f6f8fa",
        padding: "12px",
        borderRadius: "8px",
        marginBottom: "20px",
      }}
    >
      <span style={{ fontWeight: "700", color: "#1E1E1E" }}>Total Amount:</span>
      <span style={{ fontSize: "18px", fontWeight: "700", color: "#007bff" }}>
        {formatAmountWithSymbol(totalAmount.toFixed(2),user?.country_code)}
      </span>
    </div>

    {/* Buttons */}
    <div style={{ display: "flex", gap: "10px" ,marginTop:"20px" }}>
      <button
        onClick={() => setShowConfirmModal(false)}
        style={{
          flex: 1,
          padding: "10px 0",
          border: "1px solid #ccc",
          borderRadius: "6px",
          fontWeight: "600",
          background: "#fff",
          cursor: "pointer",
        }}
      >
        Cancel
      </button>
      <button
        onClick={() => { openRazorpayCheckout();setShowConfirmModal(false)}}
        style={{
          flex: 1,
          padding: "10px 0",
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          fontWeight: "600",
          cursor: "pointer",
        }}
      >
        Procced to pay
      </button>
    </div>
  </div>
</Modal>

)}

    </div>
  )
}

export default SubscriptionPlans;